// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__360Cw","column":"style_column__mVpiQ","row":"style_row__1Te8i"};